<template>
  <section>
    <div>
      <div v-if="showFields?.board_field" v-loading="loading" :element-loading-text="loadingText">
        <el-card class="main-chart-container !px-0" id="layoutBoardView">
          <div class="flex items-center justify-between !w-full">
            <div class="">{{ getFieldLabel }}</div>
            <div class="flex items-center">
              <div v-if="quickAddEntity">
                <quickEntityAddWidget
                  :currentEntity="quickentityData"
                  :parentForm="form"
                  :parentFields="fieldsData"
                ></quickEntityAddWidget>
              </div>
              <el-select
                v-model="showFields.board_field"
                placeholder="Select board field"
                @change="setCurrentField(true)"
              >
                <el-option
                  v-for="(field, i) in getEntityFieldsByType(['SELECT', 'ENTITY'])"
                  :key="field.key + 'chart' + i"
                  :label="field.label"
                  :value="field.key"
                >
                  {{ field.label }}
                </el-option>
              </el-select>
              <el-select
                v-if="
                  !isApplicationUserSide &&
                  selectedField &&
                  selectedField.input_type == 'ENTITY' &&
                  quickentityData &&
                  selectedEntityData &&
                  selectedEntityData.length
                "
                clearable
                collapse-tags
                filterable
                remote
                multiple
                :loading="entityFieldLoading"
                loading-text="fetching..."
                :remote-method="(query) => searchEntityData(query)"
                @clear="searchEntityData('')"
                v-model="selectedDataIds"
                placeholder="Select Data to show"
                class="pl-2"
                :multiple-limit="15"
              >
                <el-option
                  v-for="(temp, i) in selectedEntityData"
                  :key="i"
                  :value="temp._id"
                  :label="getLabel(temp, quickentityData, i)"
                ></el-option>
              </el-select>
              <el-button
                v-if="checkEntityOptionsButtonVisible"
                plain
                type="success"
                size="mini"
                class="px-2 ml-2 !h-fit !rounded-md"
                @click="fetchEntityFieldsData"
                title="Save"
              >
                <i class="el-icon-check"></i>
              </el-button>
            </div>
          </div>
          <div class="chart-main-container">
            <el-scrollbar>
              <div
                class="pie-body grid grid-cols-1 md:!grid-cols-2 lg:!grid-cols-3 xl:!grid-cols-4 2xl:!grid-cols-5"
                v-if="getSelectedFieldsOptions && getSelectedFieldsOptions.length"
              >
                <div
                  v-for="(col, i) in getSelectedFieldsOptions"
                  :key="i + 'column' + col"
                  class="board-column bg-[#2F80ED1A] rounded-md !py-2"
                >
                  <div class="flex items-center justify-between gap-2 !px-3">
                    <div
                      class="text-[#2F80ED] !bg-blue-100 text-xs 2xl:text-smd font-normal flex items-center !gap-1.5 !px-2 !py-1 rounded-md heading"
                    >
                      <span class="block size-2 rounded-full bg-[#2F80ED]"></span>
                      <span>{{ getSelectedFieldLabels[i] | truncate(20, '...') }}</span>
                    </div>

                    <img
                      @click="addEntityData(i)"
                      class="size-6 cursor-pointer"
                      src="@/assets/img/icons/new/addPlus-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="board-column-body px-3 !py-2 !mt-2">
                    <div
                      v-if="currentEntity.templates && showFields.take_value_from"
                      class="board-column-head !m-0 !border-b border-black-300 !pb-2"
                    >
                      {{ getFormattedTotalAmount(col) }} · {{ col.length }}
                      {{ getEntityName() }}
                    </div>
                    <div v-else class="board-column-head !m-0 !border-b border-[#DAE0E5] !pb-2">
                      ({{ getTotalOptionData(i) }})
                      {{ getEntityName() }}
                    </div>
                    <draggable
                      :list="col"
                      style="
                        height: calc(100vh - 360px);
                        overflow-y: auto;
                        scrollbar-width: thin;
                        scrollbar-color: var(--card-color) var(--black-100) !important;
                        padding-right: 5px;
                        margin: 10px 0 0 0;
                        overflow-x: hidden;
                      "
                      group="people"
                      :disabled="!checkPerimission('EDIT')"
                      @scroll="handleScroll()"
                    >
                      <div
                        v-for="(data, index) in col"
                        :key="data._id"
                        class="card mb-2"
                        @drop="checkEntityDataSwipe(data, i)"
                        :ref="setLastDivRef(index, col)"
                      >
                        <div class="card-body !p-2">
                          <div class="flex items-center justify-between !mb-2 w-full">
                            <h5
                              class="bg-[#2F80ED1F] px-2 py-1 rounded-md text-[#2F80ED] font-normal m-0 max-w-[50%] truncate cursor-pointer"
                              v-if="entityFields"
                              @click="viewWorkUserData(data)"
                            >
                              {{ getLabel(data) | truncate(20, '...') }}
                            </h5>
                            <div
                              class="iconsContainer flex flex-shrink-0"
                              v-if="showFields.enableOtherOptions"
                            >
                              <template
                                v-if="
                                  (customization &&
                                    customizationButtons &&
                                    customizationButtons.length) ||
                                  (customization != null &&
                                    customization.actions &&
                                    customization.actions.length &&
                                    getIframeUrlInfo == null)
                                "
                              >
                                <div class="iconsContainer">
                                  <button
                                    v-for="(action, index) in primaryActions"
                                    :key="index"
                                    class="icon-circle btn btn-light btn-sm mt-2 mb-1"
                                    :style="{
                                      backgroundColor: getBackgroundColor(action, data),
                                    }"
                                    @click="onAction(action, data)"
                                  >
                                    <el-tooltip
                                      placement="top"
                                      :content="getTooltipContent(action, data)"
                                      style="align-items: center"
                                    >
                                      <template v-if="!action.icon">
                                        <i
                                          :class="fetchActionIcon(action)"
                                          style="font-size: 14px"
                                        ></i>
                                      </template>
                                      <template v-else>
                                        <icons
                                          :iconName="action.icon"
                                          style="font-size: 14px"
                                        ></icons>
                                      </template>
                                    </el-tooltip>
                                  </button>
                                  <button
                                    class="btn btn-light btn-sm m-lr-1"
                                    type="button"
                                    v-for="button in getButtonsList(customizationButtons)"
                                    :key="button"
                                  >
                                    <span
                                      v-if="
                                        button === 'Edit' && checkRolePermission('editEntitiesData')
                                      "
                                      class="text-muted"
                                      title="Edit"
                                      @click="editWorkUserData(data)"
                                    >
                                      <i class="el-icon-edit"></i>
                                    </span>
                                    <span
                                      v-else-if="
                                        button === 'View' && checkRolePermission('viewEntitiesData')
                                      "
                                      class="text-muted"
                                      title="View"
                                      @click="viewWorkUserData(data)"
                                    >
                                      <i class="fa fa-eye"></i>
                                    </span>
                                    <span
                                      v-else-if="
                                        button === 'Audit Logs' && checkRolePermission('Audit Logs')
                                      "
                                      class="text-muted"
                                      title="Audit Logs"
                                      @click="showAuditLogs(data)"
                                    >
                                      <i class="el-icon-sort" style="transform: rotate(90deg)"></i>
                                    </span>
                                    <span
                                      v-else-if="
                                        button === 'Delete' &&
                                        checkRolePermission('deleteEntitiesData')
                                      "
                                      class="text-muted"
                                      title="Delete"
                                      @click="onEntityDataDelete(data)"
                                    >
                                      <i class="el-icon-delete"></i>
                                    </span>
                                    <span
                                      v-else-if="button === 'Send Notification'"
                                      class="text-muted"
                                      title="Send Notification"
                                      @click="openSendNotification(data)"
                                    >
                                      <i class="fa-solid fa-share"></i>
                                    </span>
                                  </button>
                                </div>
                                <el-dropdown
                                  v-if="showFields.enableOtherOptions"
                                  :class="dropdownPositionClass"
                                >
                                  <span class="el-dropdown-link">
                                    <img
                                      src="@/assets/img/icons/new/more-icon.svg"
                                      alt=""
                                      class="w-3 h-3"
                                    />
                                  </span>

                                  <el-dropdown-menu slot="dropdown">
                                    <a
                                      :underline="false"
                                      @click="duplicateEntityData(data)"
                                      v-if="
                                        checkPerimission('DUPLICATE') &&
                                        currentEntity &&
                                        currentEntity.entity_type != 'INDIVIDUAL'
                                      "
                                    >
                                      <el-dropdown-item
                                        icon="el-icon-document-copy"
                                        v-if="checkButtonVisible('Duplicate')"
                                      >
                                        Duplicate
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="editWorkUserData(data)"
                                      v-if="
                                        checkButtonVisible('Edit') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some((button) => button === 'Edit')
                                        ) &&
                                        checkRolePermission('editEntitiesData')
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-edit">Edit</el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="viewWorkUserData(data)"
                                      v-if="
                                        customization != null &&
                                        checkButtonVisible('View') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some((button) => button === 'View')
                                        ) &&
                                        checkRolePermission('viewEntitiesData')
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-view">View</el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="$emit('open-attachments', data)"
                                      v-if="
                                        checkPerimission('Attachments') &&
                                        checkButtonVisible('Attachments') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some(
                                            (button) => button === 'Attachments'
                                          )
                                        )
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-folder">
                                        Attachment
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="$emit('open-SendNotification', data)"
                                      v-if="
                                        checkPerimission('SEND NOTIFICATION') &&
                                        checkButtonVisible('Send Notification') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some(
                                            (button) => button === 'Send Notification'
                                          )
                                        )
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-s-promotion">
                                        Send Notification
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="openExportCSVDialog(data._id)"
                                      v-if="
                                        checkPerimission('EXPORT') &&
                                        checkButtonVisible('Export') &&
                                        checkRolePermission('viewEntitiesData') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some((button) => button === 'Export')
                                        ) &&
                                        data.status !== 'DRAFT'
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-upload2">
                                        Export
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="showAuditLogs(data)"
                                      v-if="
                                        currentEntity.enable_activity_logs &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some(
                                            (button) => button === 'Audit Logs'
                                          )
                                        ) &&
                                        checkButtonVisible('Audit Logs') &&
                                        checkRolePermission('viewEntitiesData') &&
                                        data.status !== 'DRAFT'
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-sort">
                                        Show Logs
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="$emit('open-WASendNotification', data)"
                                      v-if="
                                        checkPerimission('SEND NOTIFICATION') &&
                                        checkButtonVisible('Send Notification') &&
                                        IframePermissions('SEND NOTIFICATION', 'ViewEntityData') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some(
                                            (button) => button === 'Send Notification'
                                          )
                                        )
                                      "
                                    >
                                      <el-dropdown-item>
                                        <i class="el-icon-chat-dot-round"></i>
                                        Send WA Notification
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      :underline="false"
                                      @click="createForum(data._id)"
                                      v-if="
                                        checkButtonVisible('Create Discussion Forum') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some(
                                            (button) => button === 'Create Discussion Forum'
                                          )
                                        )
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-plus">
                                        Create Discussion Forum
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      v-if="
                                        checkButtonVisible('View Discussion Forums') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some(
                                            (button) => button === 'View Discussion Forums'
                                          )
                                        )
                                      "
                                      :underline="false"
                                      @click="viewForums(data._id)"
                                    >
                                      <el-dropdown-item icon="el-icon-view">
                                        View Discussion Forums
                                        <el-badge
                                          v-if="getUnreadCount(data._id)"
                                          :value="getUnreadCount(data._id)"
                                          type="primary"
                                        ></el-badge>
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      @click="onEntityDataDelete(data)"
                                      :underline="false"
                                      v-if="
                                        checkPerimission('DELETE') &&
                                        IframePermissions('DELETE', 'ViewEntityData') &&
                                        checkButtonVisible('Delete') &&
                                        !(
                                          customizationButtons &&
                                          customizationButtons.some((button) => button === 'Delete')
                                        ) &&
                                        checkRolePermission('deleteEntitiesData')
                                      "
                                    >
                                      <el-dropdown-item icon="el-icon-delete">
                                        Delete
                                      </el-dropdown-item>
                                    </a>
                                    <a
                                      v-for="(action, index) in nonPrimaryActions"
                                      :key="index"
                                      @click="onAction(action, data)"
                                      :underline="false"
                                    >
                                      <el-dropdown-item
                                        style="display: flex; align-items: center; gap: 2px"
                                      >
                                        <i
                                          v-if="!action.icon"
                                          :class="fetchActionIcon(action)"
                                          style="font-size: 16px"
                                        ></i>
                                        <icons
                                          v-else
                                          :iconName="action.icon"
                                          style="font-size: 14px"
                                        ></icons>
                                        <span>{{ action.label }}</span>
                                      </el-dropdown-item>
                                    </a>
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </template>
                            </div>
                          </div>
                          <div class="card-text">
                            <div
                              v-for="row in showFields.BoardViewFields"
                              :key="row"
                              class="mb-2 each-row"
                            >
                              <span class="bold-key">{{ getFieldLabels(row) }}</span>
                              :
                              <span v-if="getFieldType(row) === 'HYPER_LINK'">
                                <a
                                  :href="getFieldValue(row, data)"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  {{ getFieldValue(row, data) | truncate(22, '...') }}
                                </a>
                              </span>
                              <span v-else-if="getFieldType(row) === 'FILE'">
                                <el-tooltip
                                  placement="top"
                                  :content="getFieldValue(row, data).fileName"
                                >
                                  <a
                                    v-if="getFieldValue(row, data)"
                                    :href="getFieldValue(row, data).filePath"
                                    target="_blank"
                                  >
                                    {{
                                      getFieldValue(row, data).fileName ||
                                      '---' | truncate(24, '...')
                                    }}
                                  </a>
                                </el-tooltip>
                              </span>
                              <span v-else>
                                {{ getFieldValue(row, data) | truncate(22, '...') }}
                              </span>
                            </div>
                          </div>
                          <template
                            v-if="
                              showFields.Board_action_group_button &&
                              showFields.Board_action_group_button.length
                            "
                          >
                            <div class="mt-3">
                              <div
                                v-for="(action, index) in showFields.Board_action_group_button"
                                :key="index"
                              >
                                <a
                                  href="javascript:void(0);"
                                  class="card-link text-primary"
                                  @click="
                                    onActionButtonOpen(
                                      {
                                        template_id: action.split('#')[0],
                                        id: action.split('#')[1],
                                      },
                                      data
                                    )
                                  "
                                >
                                  {{ getActionField(action) }}
                                </a>
                              </div>
                            </div>
                          </template>
                        </div>
                      </div>
                    </draggable>
                    <div class="load-more">
                      <el-button
                        :disabled="loadMoreLoading"
                        v-loading="loadMoreLoading"
                        element-loading-text="Fetching data"
                        v-if="checkLoadMoreVisible(getSelectedFieldLabels[i])"
                        @click="loadMore(getSelectedFieldLabels[i])"
                      >
                        Load more
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="entity-empty" v-else>
                <el-empty :description="getDescription"></el-empty>
              </div>
            </el-scrollbar>
          </div>
        </el-card>
      </div>
      <div class="entity-empty" v-else>
        <el-empty :description="getDescription"></el-empty>
      </div>

      <div v-if="quickActionModal && quickActionDummyField">
        <ActionButtonExecute
          :data="quickActionDummyField"
          :isView="false"
          :currentMenu="currentMenu"
          :entityId="currentEntity._id"
          :entityDataId="quickActionDummyField.parent_entityDataId"
          :fromQuickAction="true"
          @closeModal="quickActionModal = false"
        ></ActionButtonExecute>
      </div>
    </div>
    <el-drawer
      title="Activity Logs"
      :visible.sync="showLogs"
      :direction="'rtl'"
      class="layout-drawer"
      :size="getIsMobile ? '80%' : '40%'"
      :before-close="handleLogsBeforeClose"
    >
      <AuditLogs
        v-if="showLogs"
        :fieldsObject="currentEntityFieldsObject"
        :createdAtData="createdAtData"
      />
    </el-drawer>
  </section>
</template>
<script>
  import axios from '@/config/axios';
  import { postAPICall } from '@/helpers/httpHelper';
  import CustomDashboardConfig from '@/mixins/CustomDashboardHelper.js';
  import EntitiesHelper from '@/mixins/EntitiesHelper';
  import FieldsFormatHelper from '@/mixins/FieldsFormatHelper';
  import NavigationHelper from '@/mixins/navigationHelper';
  import { fetchEntityById } from '@/repo/entityRepo';
  import { fetchFilterById } from '@/repo/filtersRepo';
  import DataParseWorkerFile from '@/workers/dataParse.worker.js';
  import { wrap } from 'comlink';
  import draggable from 'vuedraggable';
  import { mapGetters } from 'vuex';
  import { getAllFieldsArrayFromEntity } from '../../../utils/formatter';

  export default {
    data() {
      return {
        createdAtData: null,
        showLogs: false,
        field: {},
        copyData: [],
        localShowFields: { ...this.showFields },
        fieldId: '',
        workers: null,
        currentBoardViewFields: null,
        selectedDataIds: [],
        selectedEntityData: [],
        entityFieldLoading: false,
        idsToFetchEntityLabelsObj: [],
        dataParseWorker: null,
        formattedEntityData: [],
        fieldsObject: null,
        primaryTemplateId: null,
        optionsHasMoreObject: null,
        pageLimit: 30,
        loadMoreLoading: false,
        lastDivRef: null,
        showWidget: false,
        selectedField: null,
        entityOptionsObj: null,
        entityOptionsIdObj: null,
        quickentityData: null,
        number_fields: [],
        required_sum: 0,
        tagType: ['success', 'info', '', 'warning', 'danger'],
        chartData: {
          labels: [],
          datasets: [
            {
              backgroundColor: [],
              data: [],
              label: '',
            },
          ],
        },
        chartOptions: {
          responsive: true,
          maintainAspectRatio: false,
        },
        componentData: {},

        baseColor: '#65cff0',
        loading: false,
        entity_id: '',
        currentEntity: {},
        loadingText: 'Gathering data...',
        refresh: false,
        chartTypes: [
          {
            label: 'Pie',
            value: 'PIE',
          },
          {
            label: 'Bar',
            value: 'BAR',
          },
          {
            label: 'Doughnut',
            value: 'DOUGHNUT',
          },
        ],
        allEntityDataList: [],
        getSelectedFieldsOptions: [],
        getSelectedFieldLabels: [],
        getSelectedFieldEntityLabels: [],
        getStandardSelectedFieldOptions: [],
        customDashboardBoardStats: null,
        entityFields: [],
        selectedEntityFields: [],
        quickActionModal: false,
        quickActionDummyField: null,
        relationalDataOfEntityData: {},
        sortOrder: -1,
        sortBy: '_id',
      };
    },
    computed: {
      ...mapGetters('templatesData', [
        'getTemplateDeleteStatus',
        'getTemplateDeleteError',
        'getDownloadUrl',
        'getDownloadError',
        'getDuplicateEntityData',
        'getDuplicateDataCheck',
      ]),
      ...mapGetters('navigationOpen', ['getIsOpen', 'getIsCollapse', 'getIsMobile']),
      ...mapGetters('entities', [
        'getEntityDataById',
        'getEntityDataByEntityId',
        'getEntityDataUpdateStatus',
        'getEntityDocumentsDataStatus',
        'getEntityDocumentsData',
        'getUploadCSVfileStatus',
        'getupdateMappedFieldStatus',
        'getmappedFieldsData',
        'getuploadedFilesData',
        'getstoreUploadedFileStatus',
        'getimportMappedDataStatusUpdatedVersion',
        'getentitydataBulkDeleteStatus',
        'getEntitydataBulkDeleteErrors',
        'geCustomDashboardPieStats',
      ]),
      ...mapGetters('applicationUsersPermission', [
        'getCreatePermissionStatus',
        'getEntityPermission',
        'getUpdatePermissionStatus',
      ]),
      ...mapGetters('companyTemplates', ['getSingleCompanyTemplate']),
      dropdownPositionClass() {
        return 'dropdown-bottom';
      },
      checkEntityOptionsButtonVisible() {
        return (
          !this.isApplicationUserSide &&
          this.selectedField?.input_type === 'ENTITY' &&
          this.selectedDataIds?.length &&
          JSON.stringify(this.selectedDataIds) !==
            JSON.stringify(this.showFields.entityFieldSelectedOptions)
        );
      },
      getFieldLabel() {
        if (this.showFields?.board_field) {
          if (this.showFields?.board_field && this.showFields.board_field.includes('#')) {
            let field = this.getEntityFieldsByType(['SELECT', 'ENTITY']).find(
              (e) => e.key == this.showFields.board_field
            );
            if (field?.label) {
              return field.label;
            }
            return this.currentEntity?.name;
          }
          return this.currentEntity?.name;
        }
        return this.currentEntity?.name;
      },
      getDescription() {
        if (!this.showFields.board_field) {
          return 'Field not selected...';
        }
        return 'No options...';
      },
      quickAddEntity() {
        return (
          this.selectedField?.entity_id &&
          this.selectedField?.allow_quick_add &&
          this.selectedField?.inputType === 'ENTITY'
        );
      },
      getCount() {
        return (col) => {
          if (
            this.showFields.board_field &&
            this.showFields.board_field.includes('#') &&
            col &&
            this.allEntityDataList
          ) {
            let count = 0;
            let [temp, key] = this.showFields.board_field.split('#');
            this.allEntityDataList.forEach((data) => {
              if (
                data?.entityData &&
                temp &&
                data.entityData[temp] &&
                data.entityData[temp][key] &&
                data.entityData[temp][key] == col
              ) {
                count++;
              }
            });
            return count;
          }
          return 0;
        };
      },
      getCards() {
        return (col, type) => {
          if (this.showFields.board_field?.includes('#') && col && this.formattedEntityData) {
            let result = [];
            let key = this.showFields.board_field;
            if (type === 'ENTITY') {
              key += '/name';
            }
            this.formattedEntityData.forEach((data) => {
              if (data?.[key] == col) {
                result.push(data);
              }
            });
            return result;
          }
          return [];
        };
      },
      nonPrimaryActions() {
        if (this.customization) {
          return this.customization.actions.filter((action) => !action.QAPrimary && action.active);
        }
        return [];
      },
      primaryActions() {
        if (this.customization) {
          return this.customization.actions.filter((action) => action.QAPrimary && action.active);
        }
        return [];
      },
    },
    mixins: [NavigationHelper, EntitiesHelper, FieldsFormatHelper, CustomDashboardConfig],
    components: {
      quickEntityAddWidget: () => import('@/components/widgets/quickEntityAddWidget'),
      draggable,
      ActionButtonExecute: () =>
        import('@/components/templates/formComponentsExecute/ActionButtonExecute'),
      AuditLogs: () => import('@/components/AuditLogs.vue'),
    },
    async created() {
      const dataParseWorkerInstance = new DataParseWorkerFile();
      this.dataParseWorker = wrap(dataParseWorkerInstance);
      await Promise.all([
        this.dataParseWorker?.setStoreData({
          defaultDateFormat: this.getDefaultDateFormat || 'DD-MM-YYYY',
          timeFormat: this.getDefaultTimeFormat === 12 ? 'hh:mm A' : 'HH:mm:ss',
        }),
      ]);
      this.$bus.$on('relation-rules-exist', this.handleRelationRules);
    },
    watch: {
      'showFields.board_field': {
        handler: async function (newValue) {
          this.showFields.board_field = newValue;
          this.getSelectedFieldsOptions = [];
          this.getSelectedFieldLabels = [];
          this.$emit('SaveData');
          const selectedField = this.getEntityFieldsByType(['SELECT', 'ENTITY']).find(
            (e) => e.key === newValue
          );
          if (selectedField?.inputType === 'SELECT') {
            await this.loadBoardData();
          }
        },
        deep: true,
      },
      showFields: {
        handler: function () {
          if (JSON.stringify(this.showFields) != JSON.stringify(this.showFields)) {
            this.localShowFields = { ...this.showFields };
            this.updateShowFields();
          }
        },
        deep: true,
      },
      entityViewModal: {
        async handler() {
          if (!this.entityViewModal) {
            if (
              JSON.stringify(this.currentBoardViewFields) !=
              JSON.stringify(this.showFields.BoardViewFields)
            ) {
              this.loadBoardData();
              this.currentBoardViewFields = JSON.parse(
                JSON.stringify(this.showFields.BoardViewFields || [])
              );
            }
          }
        },
        deep: true,
      },
      appliedQuickFilters: {
        handler() {
          this.loadBoardData();
        },
        deep: true,
        immediate: true,
      },
    },
    props: [
      'currentEntityFieldsObject',
      'data',
      'form',
      'entityId',
      'search_string',
      'showFields',
      'entityViewModal',
      'isApplicationUserSide',
      'currentMenu',
      'fieldsData',
      'getSelfEntityFilters',
      'applyFiltersData',
      'entityFiltersData',
      'appliedQuickFilters',
      'entityUserFiltersData',
      'customization',
      'viewForums',
      'createForum',
    ],
    mounted() {
      this.entity_id = this.$route.params.entity_id || this.entityId;
      if (this.$route.query.board_field) {
        this.showFields.board_field = this.$route.query.board_field;
      }
      this.getNecessaryInfo();
    },
    methods: {
      getUnreadCount(id) {
        return this.unreadCommentedThreadsCount?.find((data) => data._id == id)?.count || 0;
      },
      handleLogsBeforeClose() {
        this.showLogs = false;
      },
      async showAuditLogs(row) {
        this.createdAtData = {
          created_at: row.created_at,
          action_by: row.created_by,
          is_create: true,
          _id: row.entity_data_id,
        };

        this.showLogs = false;
        await this.$nextTick();

        this.showLogs = true;
      },
      getStarRating(rating, maxStars = 5) {
        let stars = '';
        for (let i = 1; i <= maxStars; i++) {
          if (rating >= i) {
            stars += '★';
          } else if (rating >= i - 0.9) {
            stars += '⯪';
          } else {
            stars += '☆';
          }
        }
        return `${stars} (${rating})`;
      },
      getTotalOptionData(i) {
        let key =
          this.selectedField?.input_type == 'ENTITY'
            ? this.entityOptionsObj[this.getSelectedFieldLabels[i]]
            : this.getSelectedFieldLabels[i];
        return this.optionsHasMoreObject?.[key]?.total;
      },
      async fetchEntityFieldsData() {
        this.showFields.entityFieldSelectedOptions = [...this.selectedDataIds];
        this.getSelectedFieldsOptions = new Array(this.selectedDataIds?.length)
          .fill()
          .map(() => []);
        this.loadBoardData();
        let params = {
          name: this.currentEntity.name,
          id: this.currentEntity._id,
          views_configuration: {
            ...this.showFields,
          },
        };
        await postAPICall('PUT', `/entities/${this.currentEntity._id}`, params);
      },
      async prepareFormDataForTable() {
        this.formattedEntityData = [];
        this.formattedEntityData = await this.dataParseWorker.formatDataForTable({
          dataArray: this.allEntityDataList,
          columnList: this.entityFields,
          fieldsObject: this.fieldsObject,
        });
      },
      sortedData(col) {
        return col.toSorted((a, b) => {
          const aRecentTimestamp =
            new Date(a.updated_at) > new Date(a.created_at)
              ? new Date(a.updated_at)
              : new Date(a.created_at);
          const bRecentTimestamp =
            new Date(b.updated_at) > new Date(b.created_at)
              ? new Date(b.updated_at)
              : new Date(b.created_at);
          return bRecentTimestamp - aRecentTimestamp;
        });
      },
      async handleRelationRules(filters = []) {
        if (this.currentMenu?.entity_type == 'RELATIONAL_ENTITY' && this.isApplicationUserSide) {
          filters = [...filters, ...this.getSelfEntityFilters];
        }
        filters = [
          ...filters,
          ...(this.entityFiltersData.filters || []),
          ...(this.entityUserFiltersData.filters || []),
          ...(this.appliedQuickFilters || []),
        ];
        this.loadingText = 'Gathering ' + this.currentEntity?.name + ' data';
        let primaryActions;
        let relationalEntities = [];
        let relationalData;
        if (this.customization) {
          primaryActions = this.customization.actions.filter(
            (action) => action.QAPrimary == true && action.active
          );
          if (primaryActions) {
            relationalEntities = primaryActions
              .map((action) => action.relational_entity_one)
              .filter((entity) => entity !== undefined);
          }
        }
        let params = {
          entity_id: this.entity_id,
          template_fields_data: getAllFieldsArrayFromEntity(this.currentEntity),
          format_data: true,
          filters: [...this.applyFiltersData.filters, ...filters],
          include_contact_profile: true,
          relationalEntities: relationalEntities,
        };

        //v2 has to be updated with relationalEntityResponse
        const response = await axios.post('/entities-data/entity/data', params);
        if (response?.data?.relationaldataIdsObject) {
          if (primaryActions.length > 0) {
            const requests = primaryActions.map(async (action) => {
              let relationalEntity = await fetchEntityById(action.relational_entity_one);
              const params = {
                entity_id: action.relational_entity_one,
                template_fields_data: getAllFieldsArrayFromEntity(relationalEntity),
                format_data: true,
              };
              if (action?.filter) {
                let currentFilter = await fetchFilterById(action.filter);
                params['filters'] = [...(currentFilter?.filters || [])];
              }
              return axios.post('/entities-data/entity/data/v2', params);
            });

            try {
              const relationalDataResponses = await Promise.all(requests);
              relationalData = relationalDataResponses.map((response) => response?.data?.data);
            } catch (error) {
              console.error('Error fetching relational data', error);
            }
          }
          this.relationalDataOfEntityData = Object.keys(
            response.data.relationaldataIdsObject
          ).reduce((acc, key) => {
            acc[key] = response.data.relationaldataIdsObject[key].map((id) => {
              for (const dataChunk of relationalData) {
                const found = dataChunk.data.find((item) => item._id === id);
                if (found) return found;
              }
              return undefined;
            });
            return acc;
          }, {});
        }
      },
      getSelectedValue(action, data) {
        const matchingValue = Object.keys(this.relationalDataOfEntityData).find(
          (key) => key === data._id
        );
        if (matchingValue) {
          const ruleValues = [];
          action.rules?.forEach(() => {
            this.relationalDataOfEntityData[matchingValue].forEach((matchedObject) => {
              if (action.relational_entity_one === matchedObject?.entity_id) {
                matchedObject.templates_data.forEach((templateData) => {
                  const id = templateData.template_id;
                  const value = matchedObject.entityData[id];
                  ruleValues.push(value);
                });
              }
            });
          });
          if (ruleValues.length > 0) {
            const priorityKey = action.priority?.split('#')[1];
            const isFullDateTime = (value) => value.includes('T');
            const parseDateTimeOrTime = (value) => {
              if (isFullDateTime(value)) {
                return new Date(value);
              } else {
                const [hours, minutes, seconds] = value.split(':').map(Number);
                const now = new Date();
                now.setHours(hours, minutes, seconds, 0);
                return now;
              }
            };
            if (action.order === 'ascending') {
              ruleValues.sort(
                (a, b) => parseDateTimeOrTime(a[priorityKey]) - parseDateTimeOrTime(b[priorityKey])
              );
            } else if (action.order === 'descending') {
              ruleValues.sort(
                (a, b) => parseDateTimeOrTime(b[priorityKey]) - parseDateTimeOrTime(a[priorityKey])
              );
            }
            return ruleValues[0];
          }
        }
        return null;
      },
      getBackgroundColor(action, data) {
        const selectedValue = this.getSelectedValue(action, data);
        if (selectedValue) {
          const form = this.applyFormRules(selectedValue, [], action.rules);
          if (Array.isArray(form?.action)) {
            const colorAction = form.action.find(
              (action) => action.operator_type === 'CHANGE_COLOR'
            );
            return colorAction?.color || 'white';
          } else {
            return form?.action?.color || 'white';
          }
        }
        return action.color ? action.color : 'white';
      },
      getTooltipContent(action, data) {
        const selectedValue = this.getSelectedValue(action, data);
        if (selectedValue) {
          const form = this.applyFormRules(selectedValue, [], action.rules);
          if (Array.isArray(form?.action)) {
            const colorAction = form.action.find((action) => action.operator_type === 'UPDATE');
            return colorAction?.value || action.label;
          } else {
            return form?.action?.value || action.label;
          }
        }

        return action.label;
      },
      async getTemplateData(templateId) {
        await this.$store.dispatch('companyTemplates/fetchSingleCompanyTemplate', templateId);
        return this.getSingleCompanyTemplate;
      },
      checkRolePermission(permission) {
        if (this.getUserType?.permissionSet && !this.isApplicationUserSide) {
          return this.getUserType.permissionSet.includes(permission);
        }
        return true;
      },
      async setCurrentField(isChange = false) {
        let field = this.getEntityFieldsByType(['SELECT', 'ENTITY']).find(
          (e) => e.key == this.showFields.board_field
        );
        if (!field) {
          this.showFields.board_field = null;
          return;
        }
        this.selectedField = field;
        if (field.inputType == 'ENTITY' && field.entity_id) {
          this.$emit('SaveData');
          if (isChange) {
            this.selectedDataIds = [];
            this.showFields.entityFieldSelectedOptions = [];
          }
          this.quickentityData = await fetchEntityById(field.entity_id, false);
          this.selectedEntityData = await this.fetchEntitiesDataForTables(this.quickentityData);
          if (this.selectedEntityData?.length) {
            let selectedEntityFields = await this.fetchEntityDetails(
              this.quickentityData._id,
              true
            );
            let fieldsObject = {};
            this.quickentityData.primaryFields.map((e) => {
              let field = selectedEntityFields.find(
                (fd) => fd.template_id == e.template_id && fd.key == e.key
              );
              let key = e.key?.includes('#') ? e.key : e.template_id + '#' + e.key;
              fieldsObject[key] = field;
            });
            this.selectedEntityData = await this.dataParseWorker.formatDataForTable({
              dataArray: this.selectedEntityData,
              columnList: this.quickentityData.primaryFields.map((e) => {
                return {
                  template_id: e.template_id,
                  key: e.key,
                };
              }),
              fieldsObject: fieldsObject,
            });
          }
        }
      },
      updateShowFields() {
        this.$emit('update:showFields', this.localShowFields); // Emit the change to parent
      },
      getFieldLabels(item) {
        let field = this.entityFields.find((e) => e.key == item.split('#')[1]);
        if (field) {
          return field.orgLabel || '';
        }
        return '';
      },
      async addEntityData(index) {
        let query = this.getNavigationQuery(this.$route.query);
        let viewType = 'STANDARD';
        if (this.currentEntity?.entity_type == 'INDIVIDUAL') {
          viewType = 'PROFILE';
        }
        const boardField = this.showFields.board_field;
        const isEntityData = this.getSelectedFieldEntityLabels[index] !== undefined;
        const selectedIndex = isEntityData
          ? this.getSelectedFieldEntityLabels[index]
          : this.getSelectedFieldLabels[index];
        if (this.isApplicationUserSide) {
          this.$router.push({
            path: `/ap/entity-execute/${this.entity_id}`,
            query: {
              ...query,
              ...{
                menu_id: this.$route.params.menuId,
                layout: viewType,
                type: 's7aLF3NnAQg=',
                index: selectedIndex,
                board_field: boardField,
              },
            },
          });
        } else {
          let UrlPathAdd = '';
          if (this.getIframeUrlInfo != null) {
            UrlPathAdd = `/if/${this.getIframeUrlInfo._id}/entity/edit/${this.entity_id}`;
          } else {
            UrlPathAdd = `/entity/edit/${this.entity_id}`;
          }
          this.$router.push({
            path: UrlPathAdd,
            query: {
              ...query,
              ...{
                layout: viewType,
                index: selectedIndex,
                board_field: boardField,
              },
            },
          });
        }
      },
      checkEntityDataSwipe(data, col) {
        setTimeout(() => {
          this.getSelectedFieldsOptions.forEach((column, i) => {
            if (i !== col) {
              (column || []).forEach((card) => {
                if (
                  card &&
                  data &&
                  card._id === data._id &&
                  this.showFields?.board_field &&
                  this.showFields.board_field.includes('#')
                ) {
                  this.updateEntityData(this.getSelectedFieldLabels[i], data);
                }
              });
            }
          });
        }, 300);
      },
      async searchEntityData(query) {
        try {
          this.entityFieldLoading = true;
          (await this.fetchEntitiesDataForTables(this.quickentityData, 1, 500, query)) || [];
          this.entityFieldLoading = false;
        } catch (err) {
          this.entityFieldLoading = false;
          console.log('err', err);
        }
      },
      checkPerimission(access) {
        if (this.isApplicationUserSide) {
          if (
            this.getEntityPermission &&
            this.currentMenu &&
            (this.currentMenu.entity_id || this.currentMenu.relational_entity)
          ) {
            if (access == 'UPDATE') {
              access = 'EDIT';
            }
            if (this.currentMenu.entity_id) {
              let entityId = this.currentMenu.entity_id._id
                ? this.currentMenu.entity_id._id
                : this.currentMenu.entity_id;
              if (
                this.currentMenu.entity_type == 'ENTITY' &&
                this.getEntityPermission.other_entities &&
                entityId &&
                this.getEntityPermission.other_entities[entityId] &&
                this.getEntityPermission.other_entities[entityId].permissions &&
                this.getEntityPermission.other_entities[entityId].permissions.indexOf(access) != -1
              ) {
                return true;
              }
            } else if (this.currentMenu.relational_entity) {
              let entityId = this.currentMenu.relational_entity._id
                ? this.currentMenu.relational_entity._id
                : this.currentMenu.relational_entity;
              if (
                entityId &&
                this.getEntityPermission.relational_entities[entityId] &&
                this.getEntityPermission.relational_entities[entityId].permissions &&
                this.getEntityPermission.relational_entities[entityId].permissions.indexOf(
                  access
                ) != -1
              ) {
                return true;
              }
            }
            return false;
          }
          return true;
        } else {
          if (this.entityFiltersData?.permissions?.access_set && this.entityFiltersData?._id) {
            if (access == 'EDIT') {
              access = 'UPDATE';
            }
            if (access == 'IMPORT' || access == 'EXPORT') {
              return true;
            }
            return this.entityFiltersData.permissions.access_set.indexOf(access) != -1;
          }
          return true;
        }
      },
      getEntityName() {
        return this.currentEntity?.name;
      },
      async updateEntityData(selectedData, entityData) {
        for (let i = 0; i < this.getSelectedFieldsOptions.length; i++) {
          const optionList = this.getSelectedFieldsOptions[i];
          const cardIndex = optionList.findIndex((c) => c._id === entityData._id);
          if (cardIndex !== -1) {
            const updatedCard = JSON.parse(JSON.stringify(optionList[cardIndex]));
            const [temp, key] = this.showFields.board_field.split('#');

            if (this.selectedField?.inputType === 'ENTITY') {
              updatedCard[`${temp}#${key}`] = this.entityOptionsObj[selectedData];
              updatedCard[`${temp}#${key}/name`] = selectedData;
            } else {
              updatedCard[`${temp}#${key}`] = selectedData;
            }

            this.$set(optionList, cardIndex, updatedCard);
            break;
          }
        }
        let currentEntityData = this.allEntityDataList.find((e) => e._id == entityData._id);
        let [temp, key] = this.showFields.board_field.split('#');
        let tempData = {};
        Object.keys(currentEntityData.templates_fields_data).map((tk) => {
          if (tk.split('#')[0] == temp) {
            tempData[tk.split('#')[1]] = currentEntityData.templates_fields_data[tk];
          }
        });
        if (tempData) {
          let previousData = JSON.parse(JSON.stringify(tempData[key]));
          if (this.selectedField?.inputType == 'ENTITY') {
            tempData[key] = this.entityOptionsObj[selectedData];
            tempData[`${key}/name`] = selectedData;
          } else {
            tempData[key] = selectedData;
          }
          let params = {
            template_data: tempData,
            entity_data_id: entityData._id,
            template_id: temp,
            entity_id: currentEntityData.entity_id,
          };
          await this.$store.dispatch('templatesData/updateUserTemplateData', params);
          let selectedOptionData;
          if (this.selectedField?.inputType == 'ENTITY') {
            selectedOptionData = this.entityOptionsObj[selectedData];
          } else {
            selectedOptionData = selectedData;
          }
          this.optionsHasMoreObject = {
            ...this.optionsHasMoreObject,
            [previousData]: {
              ...this.optionsHasMoreObject[previousData],
              total: this.optionsHasMoreObject[previousData].total - 1,
              length: this.optionsHasMoreObject[previousData].length - 1,
            },
            [selectedOptionData]: {
              ...this.optionsHasMoreObject[selectedOptionData],
              total: this.optionsHasMoreObject[selectedOptionData].total + 1,
              length: this.optionsHasMoreObject[selectedOptionData].length + 1,
            },
          };
        }
      },
      getLabel(item, selectedEntity = this.currentEntity, index = 1) {
        let name;
        if (selectedEntity && selectedEntity.primaryFields) {
          let primaryField = selectedEntity.primaryFields[0];
          let key = primaryField.template_id + '#' + primaryField.key;
          let field = this.fieldsObject[key];
          if (!field) {
            field = primaryField;
          }
          switch (field.input_type) {
            case 'ENTITY':
              key += '/name';
              break;
          }
          name = item[key] || 'Data ' + index;
        }
        return name;
      },
      getFieldType(row) {
        const field = this.entityFields.find((e) => e.key === row.split('#')[1]);
        this.field = field;
        return field?.input_type || '';
      },
      getFieldValue(item, col) {
        let field = this.fieldsObject[item];
        let data = col[item];

        if (!field) {
          return '-';
        }

        switch (field?.input_type) {
          case 'ENTITY':
            return col[item + '/name'] || '-';
          case 'PASSWORD':
            return '********';
          case 'FILE':
            if (data?.path?.length) {
              return {
                files: data.files,
                fileName: data.file_name,
                filePath: data.path[0], // Assuming it's always an array
              };
            }
            break;

          default:
            return data;
        }

        return data || '-';
      },
      getHeadlabel() {
        if (this.showFields.take_value_from != '' || this.showFields.take_value_from != undefined) {
          let field = this.entityFields.find(
            (e) => e.key == this.showFields.take_value_from?.split('#')[1]
          );
          if (field) {
            const labelParts = field.label.split('-');
            if (labelParts.length > 1) {
              return labelParts[1].trim() + ' Total';
            } else {
              return field.label;
            }
          }
          return '';
        }
        return '';
      },
      getFormattedTotalAmount(data) {
        const takeValueFrom = this.showFields.take_value_from;
        if (!takeValueFrom) {
          console.warn('No valid take_value_from, returning empty string.');
          return '';
        }
        const [templateId, fieldKey] = takeValueFrom.split('#');
        if (!templateId || !fieldKey) {
          console.warn('Invalid take_value_from format.');
          return '';
        }
        let totalAmount = 0;
        let detectedCurrencySymbol = null;
        let hasCurrencySymbol = false;

        data.forEach((item) => {
          const valueKey = `${templateId}#${fieldKey}`;
          let value = item[valueKey];
          if (typeof value === 'string') {
            const match = value.match(/[^\d.,\s]/);
            if (match) {
              hasCurrencySymbol = true;
              if (!detectedCurrencySymbol) {
                detectedCurrencySymbol = match[0];
              }
            }
            value = value.replace(/[^0-9.-]+/g, '');
          }
          const numericValue = Number(value);
          if (!isNaN(numericValue)) {
            totalAmount += numericValue;
          }
        });
        if (hasCurrencySymbol) {
          const currencyMap = {
            '₹': 'INR',
            $: 'USD',
            '€': 'EUR',
            '£': 'GBP',
            '¥': 'JPY',
            'د.إ': 'AED',
          };
          let currencyCode = 'USD';
          if (detectedCurrencySymbol && currencyMap[detectedCurrencySymbol]) {
            currencyCode = currencyMap[detectedCurrencySymbol];
          }
          const currencyLocale = this.getLocale(currencyCode);
          try {
            const formattedTotal = new Intl.NumberFormat(currencyLocale, {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }).format(totalAmount);
            return formattedTotal;
          } catch (error) {
            return `${detectedCurrencySymbol || ''}${totalAmount.toLocaleString()}`;
          }
        } else {
          const formattedNumber = totalAmount.toLocaleString();
          return formattedNumber;
        }
      },
      loadMore(option) {
        let key =
          this.selectedField?.input_type == 'ENTITY' ? this.entityOptionsObj[option] : option;
        this.fetchEachOptionData(key, true);
      },
      checkLoadMoreVisible(option) {
        let foundIndex = this.getSelectedFieldLabels.indexOf(option);
        let key =
          this.selectedField?.input_type == 'ENTITY' ? this.entityOptionsObj[option] : option;

        const columnData = this.getSelectedFieldsOptions?.[foundIndex] || [];

        return (
          columnData.length > 30 && this.optionsHasMoreObject?.[key]?.total > columnData.length
        );
      },
      setLastDivRef(index, col) {
        if (index === this.sortedData(col).length - 1) {
          return 'lastDiv';
        }
        return null;
      },
      handleScroll() {
        const lastDiv = this.$refs.lastDiv;
        if (lastDiv) {
          const rect = lastDiv.getBoundingClientRect();
          if (rect.bottom <= window.innerHeight) {
            this.yourMethod();
          }
        }
      },
      getLocale(currency) {
        switch (currency) {
          case 'USD':
            return 'en-US';
          case 'CAD':
            return 'en-CA';
          case 'AUD':
            return 'en-AU';
          case 'INR':
            return 'en-IN';
          case 'EUR':
            return 'en-IE';
          case 'MXN':
            return 'es-MX';
          case 'ZAR':
            return 'en-ZA';
          case 'MYR':
            return 'ms-MY';
          case 'GBP':
            return 'en-GB';
          case 'AED':
            return 'ar-AE';
          default:
            return 'en-US';
        }
      },
      getActionField(item) {
        let field = this.entityFields.find((e) => e.key == item.split('#')[1]);
        return field?.orgLabel;
      },
      resetChartData() {
        this.chartData.labels = [];
        this.chartData.datasets = [
          {
            backgroundColor: [],
            data: [],
            label: '',
          },
        ];
      },
      async viewWorkUserData(row) {
        if (row._id) {
          if (this.isApplicationUserSide) {
            this.entityDataId = row._id;
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              path: `/ap/entity-view/${this.entity_id}`,
              query: {
                ...query,
                dataId: row._id,
                filter: this.currentFilter,
                menu_id: this.$route.params.menuId,
              },
            });
          } else {
            this.entityDataId = row._id;
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              path: `/entity/view/${this.entity_id}`,
              query: { ...query, dataId: row._id, filter: this.currentFilter },
            });
          }
        }
      },
      async editWorkUserData(row) {
        if (row._id) {
          let viewType = 'STANDARD';
          if (this.currentEntity?.entity_type == 'INDIVIDUAL') {
            viewType = 'PROFILE';
          }
          if (this.isApplicationUserSide) {
            this.entityDataId = row._id;
            let query = this.getNavigationQuery(this.$route.query);
            this.$router.push({
              path: `/ap/entity-execute/${this.entity_id}`,
              query: {
                ...query,
                dataId: row._id,
                filter: this.currentFilter,
                menu_id: this.$route.params.menuId,
                layout: viewType,
                page: this.$route.query.page || 1,
                pageSize: this.$route.query.pageSize || 10,
                type: 'AUfYWb7SC6U=',
              },
            });
          } else {
            this.entityDataId = row._id;
            let query = this.getNavigationQuery(this.$route.query);
            let UrlPathEdit = '';

            if (this.getIframeUrlInfo?.url_type) {
              UrlPathEdit = `/if/${this.getIframeUrlInfo._id}/entity/edit/${this.entity_id}`;
            } else {
              UrlPathEdit = `/entity/edit/${this.entity_id}`;
            }
            let path = UrlPathEdit;
            if (this.$route.path !== path) {
              this.$router.push({
                path: path,
                query: {
                  ...query,
                  dataId: row._id,
                  filter: this.currentFilter,
                  layout: viewType,
                  page: this.$route.query.page || 1,
                  pageSize: this.$route.query.pageSize || 10,
                },
              });
            }
          }
        }
      },

      async updateRouterParams() {
        let query = this.getNavigationQuery(this.$route.query);
        query['board_field'] = this.showFields.board_field;
        this.$router.push({
          name: this.$route.name,
          query: query,
        });
      },
      async loadBoardData() {
        if (this.showFields.board_field) {
          this.loading = true;
          this.loadingText = 'Gathering data...';
          let boardField = this.fieldsObject?.[this.showFields?.board_field];
          this.allEntityDataList = [];
          this.optionsHasMoreObject = {};
          this.idsToFetchEntityLabelsObj = [];
          this.getSelectedFieldLabels = [];
          if (boardField?.inputType == 'ENTITY') {
            this.entityOptionsObj = {};
            this.entityOptionsIdObj = {};
            this.selectedDataIds.map((eachId, i) => {
              let data = this.selectedEntityData.find((e) => e._id == eachId);
              let label = this.getLabel(data, this.quickentityData, i);
              this.entityOptionsIdObj[eachId] = label;
              this.entityOptionsObj[label] = eachId;
              this.getSelectedFieldLabels.push(label);
            });
            if (!this.getSelectedFieldsOptions?.length) {
              this.getSelectedFieldsOptions = new Array(this.selectedDataIds?.length)
                .fill()
                .map(() => []);
            }
          }
          let options =
            boardField?.input_type == 'ENTITY'
              ? this.showFields.entityFieldSelectedOptions || []
              : boardField?.options;
          await Promise.all(
            (options || []).map(async (op) => {
              await this.fetchEachOptionData(op, true);
            })
          );

          if (this.allEntityDataList) {
            await this.prepareFormDataForTable();
            await this.filterEntityData(this.allEntityDataList);
          }
          this.loading = false;
        }
      },
      async fetchEachOptionData(op, formatData = false) {
        this.loadMoreLoading = true;
        let params;
        const label = this.selectedField?.input_type == 'ENTITY' ? this.entityOptionsIdObj[op] : op;
        //hasMore not working properly so using total
        if (
          this.optionsHasMoreObject[op] &&
          this.optionsHasMoreObject[op].total <= this.optionsHasMoreObject[op]?.length
        ) {
          this.loadMoreLoading = false;
          return;
        }
        if (!params) {
          params = this.getParamsForFetchingData();
          params = {
            ...params,
            limit: this.pageLimit,
            page: this.optionsHasMoreObject[op]?.length / this.pageLimit + 1 || 1,
            filters: [
              ...params.filters,
              {
                field: this.showFields.board_field,
                operator: 'in',
                value: [op],
                data_type: 'ARRAY',
                query_type: 'AND',
                relational_filter_query: 'includes',
                is_date_time: false,
                input_type: 'SELECT',
              },
            ],
          };
        }
        let resp = await axios.post('/entities-data/entity/data/v2', params);
        this.allEntityDataList.push(...resp.data.data.data);
        this.optionsHasMoreObject[op] = {
          ...(this.optionsHasMoreObject[op] || {}),
          hasMore: resp.data.data.hasMore,
          length: (this.optionsHasMoreObject[op]?.length || 0) + (resp.data.data.data?.length || 0),
          total: resp.data.data.total,
        };
        if (formatData) {
          let foundIndex = this.getSelectedFieldLabels.indexOf(label);
          if (foundIndex != -1) {
            let formattedData = await this.dataParseWorker.formatDataForTable({
              dataArray: resp.data.data.data,
              columnList: this.entityFields,
              fieldsObject: this.fieldsObject,
            });
            const optionList = this.getSelectedFieldsOptions[foundIndex] || [];
            formattedData.forEach((newCard) => {
              const existingIndex = optionList.findIndex((item) => item._id === newCard._id);
              if (existingIndex !== -1) {
                this.$set(optionList, existingIndex, newCard);
              } else {
                optionList.push(newCard);
              }
            });
          }
        }
        this.loadMoreLoading = false;
      },
      getParamsForFetchingData() {
        let relationalEntities = [],
          primaryActions,
          filters = [];
        if (this.currentMenu?.entity_type == 'RELATIONAL_ENTITY' && this.isApplicationUserSide) {
          filters = [...filters, ...this.getSelfEntityFilters];
        }
        filters = [
          ...filters,
          ...(this.entityFiltersData.filters || []),
          ...(this.entityUserFiltersData.filters || []),
          ...(this.appliedQuickFilters || []),
        ];
        if (this.customization) {
          primaryActions = this.customization.actions.filter(
            (action) => action.QAPrimary == true && action.active
          );
          if (primaryActions) {
            relationalEntities = primaryActions
              .map((action) => action.relational_entity_one)
              .filter((entity) => entity !== undefined);
          }
        }
        let templateId, fieldKey;
        if (this.showFields?.take_value_from?.includes('#')) {
          [templateId, fieldKey] = this.showFields.take_value_from.split('#');
        }
        const template_fields_data = (this.currentEntity.templates || []).map((template) => {
          const fields = this.fetchTemplateFieldsInTable(template.template_id);
          if (template.template_id === templateId && fieldKey && !fields.includes(fieldKey)) {
            fields.push(fieldKey);
          }
          return {
            template_id: template.template_id,
            fields: fields,
          };
        });
        return {
          entity_id: this.entity_id,
          template_fields_data,
          filters: [...this.applyFiltersData.filters, ...filters],
          include_contact_profile: true,
          relationalEntities: relationalEntities,
          limit: 200,
        };
      },
      fetchTemplateFieldsInTable(templateId) {
        const addKeysByType = (fd, keys, key) => {
          if (!fd) return;
          const typeMap = {
            ENTITY: '/name',
            PHONE_COUNTRY_CODE: '_code',
            MASKED: '_masked',
          };
          if (typeMap[fd.input_type]) {
            keys.push(key + typeMap[fd.input_type]);
          }
        };

        const extractKey = (key) => (key?.includes('#') ? key.split('#')[1] : key);

        let allKeys = (this.showFields.BoardViewFields || [])
          .filter((e) => e.includes(templateId))
          .flatMap((fieldKey) => {
            const fd = this.fieldsObject[fieldKey];
            if (!fd) return [];
            const key = extractKey(fd.key);
            const keys = [key];
            addKeysByType(fd, keys, key);
            return keys;
          });

        if (this.showFields.board_field?.includes(templateId)) {
          const key = extractKey(this.showFields.board_field);
          if (!allKeys.includes(key)) {
            allKeys.push(key);
            addKeysByType(this.fieldsObject[this.showFields.board_field], allKeys, key);
          }
        }

        this.currentEntity.primaryFields
          .filter((e) => e.template_id === templateId)
          .forEach((fd) => {
            const key = fd.key;
            if (!allKeys.includes(key)) {
              allKeys.push(key);
              addKeysByType(this.fieldsObject[`${fd.template_id}#${key}`], allKeys, key);
            }
          });

        return allKeys;
      },
      async filterEntityData() {
        this.getSelectedFieldEntityLabels = [];
        if (this.showFields?.board_field) {
          if (this.showFields.board_field?.includes('#')) {
            let field = this.getEntityFieldsByType(['SELECT', 'ENTITY']).find(
              (e) => e.key == this.showFields.board_field
            );
            if (field?.inputType && field.inputType == 'SELECT' && field.options) {
              this.getSelectedFieldsOptions = [];
              this.getSelectedFieldLabels = [];
              field.options.forEach((op) => {
                this.getSelectedFieldsOptions.push(this.getCards(op));
                this.getSelectedFieldLabels.push(op);
                this.getStandardSelectedFieldOptions.push(this.getCards(op));
              });
            } else if (field?.inputType === 'ENTITY' && field.key) {
              let options = Object.keys(this.entityOptionsObj);
              options.forEach((op) => {
                const entityCard = this.getCards(op, 'ENTITY');
                if (this.getSelectedFieldsOptions.length < options.length) {
                  this.getSelectedFieldsOptions.push(entityCard);
                }
                if (field.inputType === 'ENTITY' && !this.getSelectedFieldLabels.includes(op)) {
                  this.getSelectedFieldLabels.push(op);
                }
                if (!this.getSelectedFieldEntityLabels.includes(this.entityOptionsObj[op])) {
                  this.getSelectedFieldEntityLabels.push(this.entityOptionsObj[op]);
                }
                if (
                  !this.getStandardSelectedFieldOptions.some(
                    (item) => JSON.stringify(item) === JSON.stringify(entityCard)
                  )
                ) {
                  this.getStandardSelectedFieldOptions.push(entityCard);
                }
              });
            }
          }
        }
      },
      async getNecessaryInfo() {
        this.loading = true;
        this.currentEntity = await fetchEntityById(this.entity_id);
        this.primaryTemplateId = this.currentEntity.templates[0].template_id;
        this.entityFields = await this.fetchEntityDetails(this.currentEntity._id, true);
        this.selectedDataIds = this.showFields.entityFieldSelectedOptions;
        this.currentBoardViewFields = JSON.parse(
          JSON.stringify(this.showFields.BoardViewFields || [])
        );
        this.fieldsObject = {};
        this.entityFields.map((e) => {
          let key = e.key?.includes('#') ? e.key : e.template_id + '#' + e.key;
          this.fieldsObject[key] = e;
        });
        await this.setCurrentField();
        this.loadBoardData();
        this.selectedEntityFields = [];
        if (this.currentEntity) {
          if (this.currentEntity?.views_configuration) {
            this.localShowFields = { ...this.currentEntity.views_configuration };
          } else if (this.showFieldsParent) {
            this.localShowFields = { ...this.showFieldsParent };
          }
          if (this.currentEntity && this.currentEntity.templates) {
            this.currentEntity.templates.forEach((e) => {
              if (e && e.templateInfo && !e.is_repeatable) {
                let dt = JSON.parse(JSON.stringify(e.templateInfo));
                this.selectedEntityFields = [
                  ...this.selectedEntityFields,
                  ...this.getTemplateFields(dt),
                ];
              }
            });
          }
        }
      },
      getTemplateFields(data) {
        let fields = [];
        data.sections.forEach((e) => {
          fields = [...fields, ...e.fields];
        });

        fields = fields.map((e) => {
          e.template_id = data._id;
          if (e.key && !e.key.includes('#')) {
            e.key = data._id + '#' + e.key;
          }
          e.template_name = data.name;
          e.data_type = e.validations && e.validations.type ? e.validations.type : 'STRING';
          return e;
        });
        fields.forEach((f) => {
          if (
            f.inputType === 'NUMBER' ||
            f.inputType === 'CURRENCY' ||
            f.inputType === 'AGGREGATE_FUNCTION' ||
            (f.inputType === 'FORMULA' && f.result_type === 'NUMBER')
          ) {
            this.number_fields.push(f);
          }
        });
        return fields;
      },
      getEntityFieldsByType(types) {
        let results = [];
        (this.currentEntity && this.currentEntity.templates
          ? this.currentEntity.templates
          : []
        ).forEach((temp) => {
          if (temp?.templateInfo?.sections && !temp.is_repeatable) {
            if (types && types.length) {
              results = [
                ...results,
                ...temp.templateInfo.sections[0].fields
                  .filter((e) => types.indexOf(e.inputType) != -1)
                  .map((el) => {
                    let key = el.key;
                    if (!key.includes('#')) {
                      key = temp.template_id + '#' + key;
                    }
                    el.key = key;
                    return el;
                  }),
              ];
            } else {
              results = [
                ...results,
                ...temp.templateInfo.sections[0].fields.map((el) => {
                  let key = el.key;
                  if (!key.includes('#')) {
                    key = temp.template_id + '#' + key;
                  }
                  el.key = key;
                  return el;
                }),
              ];
            }
          }
        });
        if (types.includes('IMAGE') && this.currentEntity?.entity_type == 'INDIVIDUAL') {
          results.push({
            label: 'Default picture',
            key: 'defaultpic',
          });
        }
        return results;
      },
      deleteEntityData(row) {
        this.$confirm('Are you sure to delete the data?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.checkDeleteEntityData(row);
        });
      },
      async checkDeleteEntityData(entityData) {
        let params = {
          id: entityData._id,
          entity_id: entityData.entity_id,
        };
        let resourceFilters = this.selectedEntityFields
          .filter((e) => {
            if (e?.inputType == 'ENTITY' && e.filters) {
              return e.filters.find((f) => f.field == 'RESOURCE_MANAGEMENT');
            }
          })
          .map((e) => {
            let newField = {
              key: e.key,
              label: e.label,
              filters: e.filters,
              entity_id: e.entity_id,
              template_id: e.template_id,
            };
            if (e.data_table_key) {
              newField['data_table_key'] = e.data_table_key;
              newField['data_table_field_index'] = e.data_table_field_index;
            }
            return newField;
          });
        if (resourceFilters && resourceFilters.length) {
          params['resource_filters'] = resourceFilters;
          params['entityData'] = entityData;
        }
        await this.$store.dispatch('templatesData/deleteEntityData', params);
        if (this.getTemplateDeleteStatus) {
          this.loadBoardData();
          this.$notify.success({
            title: 'Success',
            message: 'Entity Data deleted successfully',
          });
        } else {
          this.$notify.error({
            title: 'Error',
            message: this.getTemplateDeleteError || 'Error on deleting Entity data',
          });
        }
      },
      async duplicateEntityData(row) {
        this.loading = true;
        let data = {
          entity_id: this.entity_id,
          existed_data_id: row._id,
          current_date: this.getCurrentDate,
        };
        await this.$store.dispatch('templatesData/duplicateEntityData', data);
        if (this.getDuplicateEntityData?._id) {
          this.$notify.success({
            title: 'Success',
            message: 'Data duplicated successfully',
          });
          this.loading = false;
          this.loadBoardData();
        } else {
          this.loading = false;
          this.$notify.error({
            title: 'Error',
            message:
              'Error while duplicating ' +
              (this.currentEntity && this.currentEntity.name ? this.currentEntity.name : 'data'),
          });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .el-card {
    border: none !important;
    overflow: hidden;
    padding: 0px 10px 0px 10px !important;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .card-data {
    justify-content: first baseline;
    align-items: center;
    margin-left: 8px;
    width: 50px;
  }

  .el-card__body {
    padding: 0 !important;
  }

  .main-chart-container {
    width: 100% !important;

    .entity-navbar {
      display: flex;
      justify-content: space-between;
      align-items: center;

      @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
      }

      .left {
        .entity-title {
          color: var(--black-700);
          font-weight: 400;
          font-size: clamp(13px, 0.83vw, 16px);
        }

        order: 1;
      }

      .right {
        order: 2;
      }
    }

    .chart-main-container {
      margin-top: 8px;

      .pie-body {
        display: grid !important;
        gap: 10px;
        padding-bottom: 0.5rem;

        @media (min-width: 1921px) {
          grid-template-columns: repeat(6, 1fr) !important;
        }

        .board-column {
          width: 100%;

          .heading {
            @media (min-width: 1920px) {
              font-size: 14px !important;
            }
          }

          .board-column-heading {
            border-radius: 8px;
            color: #17181a;
            font-size: clamp(11px, 0.625vw, 14px);
            font-weight: 500;
            width: fit-content;
          }

          &:nth-of-type(even) {
            .board-column-heading {
              background: #e0cef2;
            }
          }

          &:nth-of-type(odd) {
            .board-column-heading {
              background: #cef2ce;
            }
          }

          .board-column-head {
            display: flex !important;
            text-align: center;
            margin-block: 0.5rem;
            color: var(--black-700);
            font-size: clamp(11px, 0.625vw, 12px);
            font-weight: 400;
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
  .el-card {
    border-radius: 4px;
    border: 0px solid #ebeef5;
    background-color: transparent;
    overflow: hidden;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }

  .el-card.is-always-shadow {
    box-shadow: none !important;
  }

  .card {
    background: var(--card-color) !important;
    border-radius: 10px;
    border-width: 0 0 0 3px !important;
    border-left: 3px solid #6922a6 !important;
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06) !important;

    .card-body {
      border-radius: 10px;

      h5 {
        font-size: clamp(11px, 0.72vw, 15px);
      }

      .each-row {
        font-weight: 400;
        font-size: clamp(12px, 0.72vw, 14px);
        line-height: 140%;
        color: var(--black-800);
        display: flex;
        gap: 0.5rem;

        .bold-key {
          font-weight: 400;
          font-size: clamp(11px, 0.69vw, 12px);
          color: var(--black-500);
        }
      }

      &:hover {
        box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
      }
    }

    &:hover {
      box-shadow: 0 !important;
      transform: translateY(-2px);
      transition: all 0.3s ease-in-out;
      background-color: #6822a608 !important;
    }
  }

  .add-card-button {
    display: flex;
    justify-content: center;
  }

  .circle-button {
    border: 2px solid var(--brand-400);
    border-radius: 50%;
    padding: 0;
    font-size: 18px;
    text-align: center;
    cursor: pointer;
  }

  .circle-button:hover {
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  }

  .container {
    padding: 10px;
  }

  .iconsContainer {
    display: flex;
    align-items: center;
    margin-right: 1px;
  }

  .icon-circle {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    color: white;
    font-size: 16px;
  }

  .icon-circle i,
  .icon-circle svg {
    font-size: 14px;
  }

  .load-more {
    padding: 8px 0 0;
    text-align: center;
    width: 100%;
  }

  .load-more .el-button {
    width: 100%;
    color: #fff;
    background-color: var(--brand-500);
    border: none;
    padding: 10px 0;
    font-size: clamp(11px, 0.75vw, 0.875rem);
    cursor: pointer;
    transition: background-color 0.3s ease;
    border-radius: 8px;
    font-weight: 400;
  }

  .load-more .el-button:disabled {
    background-color: var(--brand-100);
    cursor: not-allowed;
  }

  .load-more .el-button:hover:not(:disabled) {
    background-color: var(--brand-400);
  }
</style>
